import request from '@/service/request'

import store from '@/store/index'

const _permission = store.getters['login/getPermission']
const isAdmin = store.state.login.isAdmin
/* 桌球室预约记录，分页
* 接口地址准确 因为后端颠颠的，乱来 ，导致桌球室几个page接口命名不规范
* @params
* */
export const pageSnookerOrderRecordApi = (params) => {
  // 管理员查看所有数据
  // 否则按管辖球场获取数据
  const url = isAdmin || _permission.includes('snooker:room:edit') ? '/stu/snookerStuOrderRecord/page' : '/stu/snookerStuOrderRecord/pageCurrentTeacher'
  return request.post(url, params)
}

/* 桌球室预约记录，list
* @params
* */
export const listSnookerOrderRecordApi = (params = {}) => {
  return request.post('/stu/snookerStuOrderRecord/list', params)
}

/* 桌球室预约记录，根据id获取
* @params
* */
export const getSnookerOrderRecordByIdApi = (id) => {
  return request.post(`/stu/snookerStuOrderRecord/get/${id}`)
}
/* 桌球室预约记录，删除
* @params
* */
export const delSnookerOrderRecordByIdApi = (id) => {
  return request.post(`/stu/snookerStuOrderRecord/del/${id}`)
}

/* 桌球室预约记录，保存
* @params
* */
export const saveSnookerOrderRecordApi = (params) => {
  return request.post('/stu/snookerStuOrderRecord/save', params)
}

/* 桌球室预约记录，取消预约
* @params
* */
export const cancelSnookerOrderRecordApi = (fixedCode) => {
  return request.post('/stu/snookerStuOrderRecord/cancel', { fixedCode: fixedCode })
}
